import InputDecimalCell from '@/components/_common/InputDecimalCell';
import { usePurchaseItemsSellPriceUpdate } from '@/core/domain/purchase/purchaseItem/PurchaseItem.hooks';
import { PurchaseItem } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { useDisclosure } from '@/hooks';
import React from 'react';
import PurchaseItemSpan from '../PurchaseItemSpan';
import formatterPrice from '@/utils/number/formatterPrice';
import { Popover } from 'antd';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

interface Props {
  item: PurchaseItem;
}

export default function PurchaseItemSellPrice(props: Props) {
  const [isInputEnabled, inputAction] = useDisclosure(false);

  const handleUpdateUnitPrice = async (sellPriceInformed: number) => {
    try {
      await update.mutateAsync([{ id: props.item.id, sellPriceInformed }]);
    } finally {
      inputAction.close();
    }
  };

  const update = usePurchaseItemsSellPriceUpdate();

  if (isInputEnabled) {
    return (
      <InputDecimalCell
        defaultValue={props.item.sellPriceInformed}
        min={0}
        loading={update.isLoading}
        onConfirmValue={(value) => handleUpdateUnitPrice(value)}
        onClose={inputAction.close}
      />
    );
  }

  return (
    <PurchaseItemSpan
      onClick={inputAction.open}
      hasPermission={hasPermissions([
        Authorities.MOVIMENTATION_PURCHASE_ITEM_EDIT_SELL_PRICE,
      ])}
    >
      <Popover
        title="Preço de venda atual do item"
        content={formatterPrice(props.item.sellPriceCurrent)}
        placement="right"
      >
        {formatterPrice(props.item?.sellPriceInformed || 0)}
      </Popover>
    </PurchaseItemSpan>
  );
}
